import {
	Button, FloatingMenu, Grid, NumberField, Spacer
} from '@components';
import { BUTTON_TYPES, ILaneRateCard } from '@types';
import styles from './RateCard.module.scss';
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from 'react';
import EditOutlined from '@mui/icons-material/EditOutlined';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Remove from '@mui/icons-material/Remove';

type TRangeFloatingMenuProps = {
	index: number;
	rateCard?: ILaneRateCard;
	isEdit?: boolean;
	currentRange?: string;
	onEdit?: (previousRange: string, newRange: {start: string, end: string}) => void;
	onDelete?: (rangeToDelete: string) => void;
	onAdd?: (newRange: {start: string, end: string}, index: number) => void;
	isLastColumn?: boolean;
}

export const RangeFloatingMenu = (props: TRangeFloatingMenuProps) => {
	const {
		index,
		isEdit,
		currentRange,
		onEdit,
		onDelete,
		onAdd,
		isLastColumn = false
	} = props;

	const [isOpen, setIsOpen] = useState(false);
	const [range, setRange] = useState({
		start: '',
		end: '',
	});

	useEffect(() => {
		setRange({
			start: !isEdit ? '' : currentRange ? currentRange.split('-')[0] : '',
			end: !isEdit ? '' : currentRange ? currentRange.split('-')[1] : '',
		});
	}, [isEdit, currentRange])

	return (
		<FloatingMenu open={isOpen} onMenuToggle={setIsOpen}>
			{
				isEdit ? <EditOutlined className={styles.ctaButton} /> :
					<AddIcon className={styles.ctaButton} />
			}
			<FloatingMenu.Menu menuPos={isLastColumn ? 'right' : 'center'} borderRadius={0} closeOnClick={false}>
				<div className={`${styles.floatingMenuContainer} ${styles.floatingMenuContainerRange}`}>
					<Grid columns={3} gap='4px' columnTemplate='1fr 24px 1fr' alignItems='center'>
						<Grid.Item>
							<NumberField
								label='From'
								value={range.start}
								onChange={(e) => setRange((prev) => {
									return {
										start: e.target.value,
										end: prev.end,
									}
								})}
								name={'start'}
								keepErrorSpace={false}
							/>
						</Grid.Item>
						<Grid.Item>
							<Remove />
						</Grid.Item>
						<Grid.Item>
							<NumberField
								label='To'
								value={range.end}
								onChange={(e) => setRange((prev) => {
									return {
										start: prev.start,
										end: e.target.value,
									}
								})}
								name={'end'}
								keepErrorSpace={false}
							/>
						</Grid.Item>
					</Grid>
					<Spacer size={5} />
					<Button
						type={BUTTON_TYPES.TERTIARY}
						onClick={() => {
							isEdit && currentRange ? onEdit?.(currentRange, range) : onAdd?.(range, index);
							setIsOpen(false);
						}}
						disabled={!range.start || !range.end}
						text={'Apply range'}
					/>
					<Spacer size={5} />
					{
						isEdit && <>
							<Spacer size={0} divider/>
							<div className={styles.floatingMenuButton}>
								<Button
									Icon={DeleteOutline}
									type={BUTTON_TYPES.TERTIARY}
									onClick={() => {
										currentRange && onDelete?.(currentRange);
										setIsOpen(false);
									}}
									text={'Delete column'}
								/>
							</div>
						</>
					}
				</div>
			</FloatingMenu.Menu>
		</FloatingMenu>
	)
}